import { recordListingEvent } from '../../../../Redux/Actions/recordListingEvent';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import $, { map } from 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import { GET_ONE_GARAGE_LIST } from '../../../../Redux/Actions/ActionType';
import 'react-image-gallery/styles/css/image-gallery.css';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { CommonBanner } from '../CommonBanner';
import { externalUrl } from "../../../../utils/externalUrl";
import '../../../../../src/css/priority-nav-scroller.css';
import ServicesScroller from '../../../common/ServiceScroll/ServiceScroller';
import { useTranslation } from 'react-i18next';
import { getGarageCategory } from '../../../../Redux/Actions/UserAction';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/service-provider/garages/banner-2.jpg',
  },
];
const openStatus = ['OPEN', 'مفتوح'];

export default function UserGaragesDetail() {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  var home = useSelector((state) => state.home);
  const garageDetailList = home?.OnegarageDetailList;
  // Map each Arabic category name to its English (categoryEn) so the customer's
  // "Services provided" shows English in English mode. Services store the
  // category string (Arabic); we resolve to English via the category master.
  const garageCategoryList = home?.garageCategoryList?.response;
  const catEnMap = {};
  (garageCategoryList || []).forEach((c) => {
    if (c?.category) catEnMap[c.category] = c.categoryEn || c.category;
  });
  const serviceLabel = (svc) =>
    isRTL ? svc : catEnMap[svc] || svc;
  const dispatch = useDispatch();
  const { garageOwnerId } = useParams();
  useEffect(() => { if (garageOwnerId) recordListingEvent(garageOwnerId, 'garage', 'VIEW'); }, [garageOwnerId]);
  // const data = { packID: id };

  useEffect(() => {
    const fetchOneGarageDetail = async (data) => {
      var object = { garageOwnerId };
      console.log('this is fatch ondata ', object);
      let query = '';
      Object.keys(object).forEach((key) => {
        console.log('this is object key', key);
        query += key + '=' + object[key] + '&';
      });
      query = query.slice(0, -1);
      console.log('this is the,', query);
      try {
        // console.log('fetch data part', data);
        axios

          .get(
            `https://api.carsavenue.com/api/garageOwner/listing` +
              '?' +
              query,

            config
          )

          .then((res) => {
            console.log('heeee<<<<', res);
            dispatch({
              type: GET_ONE_GARAGE_LIST,
              payload: res.data.response.data,
            });

            // setgarageDataDetail(res);

            console.log('heeee<<<<', res);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        // Swal.fire('Incorrect Credentials', '', 'error');
      }
    };
    if (garageOwnerId && garageOwnerId !== '')
      fetchOneGarageDetail({ garageOwnerId });
    // Load the category master so we can show English service names.
    dispatch(getGarageCategory());
    // console.log('home data', garageDataDetail);
  }, [dispatch, garageOwnerId]);

  const [mapModalOpen, setMapModalOpen] = useState(false);

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };
  return (
    <div>
      {garageDetailList === undefined ? (
        <>
          {/* <h2>dsdasdfasdf</h2> */}
          <div
            className="text-center text-warning"
            const
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <PageLoader /> <br />
          </div>
        </>
      ) : (
        <div key="key">
          {garageDetailList.map((x, indexValue) => {
            //Social Media Data
            const socialMediaData =
              typeof x?.socialMedia === 'string'
                ? JSON.parse(x.socialMedia)
                : x?.socialMedia;

            //Business Media Data, LOGO, BANNER
            const logoData = x?.businessMedia?.find(
              (item) => item.mediaType === 'LOGO'
            );

            let bannerImages = defaultImages;

            if (x?.businessMedia && x.businessMedia.length > 0) {
              const mediaImages = x.businessMedia
                .filter(
                  (mediaItem) =>
                    mediaItem?.media?.path &&
                    (mediaItem.mediaType === 'MAIN_BANNER' ||
                      mediaItem.mediaType === 'BANNER')
                )
                .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
                  original: mediaItem.media.path,
                  thumbnail: mediaItem.media.path,
                }));

              if (mediaImages.length > 0) {
                bannerImages = mediaImages;
              }
            }

            //Business Calendar
            const businessCalendar =
              typeof x?.calendar === 'string'
                ? JSON.parse(x?.calendar)
                : x?.calendar;
            const now = new Date();
            const currentDay = now
              .toLocaleString('en-us', { weekday: 'long' })
              .toUpperCase(); // "MONDAY"

            const currentTime = now.getHours() * 60 + now.getMinutes();

            const timeToMinutes = (timeStr) => {
              const [time, period] = timeStr.split(' ');
              let [hours, minutes] = time.split(':').map(Number);
              if (period === 'PM' && hours < 12) hours += 12;
              if (period === 'AM' && hours === 12) hours -= 12;
              return hours * 60 + minutes;
            };

            let isOpen = false;
            let nextActionTime = ''; // Time for the next action

            const todaySchedule = businessCalendar?.[currentDay];

            if (todaySchedule) {
              const { status, openTime, endTime } = todaySchedule;

              if (status === 'مفتوح' || status === 'OPEN') {
                // "Open" status
                const openMinutes = timeToMinutes(openTime);
                const closeMinutes = timeToMinutes(endTime);

                if (currentTime >= openMinutes && currentTime <= closeMinutes) {
                  isOpen = true;
                  nextActionTime = endTime; // Display closing time
                } else if (currentTime < openMinutes) {
                  isOpen = false;
                  nextActionTime = openTime; // Display opening time
                } else {
                  isOpen = false;
                  nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
                }
              } else {
                isOpen = false;
                nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
              }
            }

            //Location Data
            const gpsData =
              typeof x?.gps === 'string' ? JSON.parse(x?.gps) : x?.gps;
            const lat = parseFloat((gpsData || {}).lat);
            const lng = parseFloat((gpsData || {}).long);

            return (
              <>
                <div class="user-banner">
                  <CommonBanner bannerImages={bannerImages} />

                  <div class="user-logo-holder">
                    <div class="container">
                      <div class="user-logo-holder-wrap">
                        <div class="row align-items-center justify-content-between">
                          <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                            <div class="row align-items-center">
                              <div class="col-4 col-sm-4 col-md-3">
                                <img
                                  src={logoData?.media?.path}
                                  // src='assets/images/user/garages/garage-logo/a.jpg'
                                  alt=""
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      'assets/images/service-provider/garages/logo.jpg';
                                  }}
                                  class="img-fluid user-garage-logo"
                                  style={{
                                    objectFit: 'contain',
                                    backgroundColor: '#fff',
                                  }}
                                />
                              </div>
                              <div class="col-8 col-sm-8 col-md-auto">
                                <h5 class="mb-3">{x?.garageName}</h5>
                                <ul class="list-inline mb-0 wpm">
                                  <li
                                    class="list-inline-item"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Calendar"
                                  >
                                    <a
                                      href="javascript:void(0);"
                                      data-toggle="modal"
                                      data-target="#calendar-modal"
                                    >
                                      <i class="far fa-calendar-alt"></i>
                                    </a>
                                  </li>
                                  <li
                                    class="list-inline-item"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Whatsapp"
                                  >
                                    <a
                                      target="_blank"
                                      onClick={() => recordListingEvent(garageOwnerId, 'garage', 'CONTACT')} href={`https://wa.me/${`${x?.whatsAppNumberCountryCode}${x?.whatsAppNumber}`.replace(/\D/g, '')}`}
                                    >
                                      <i class="fab fa-whatsapp"></i>
                                    </a>
                                  </li>
                                  <li
                                    class="list-inline-item"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Call"
                                  >
                                    {/* [CF 2026-08-17 #7] Also had a stray "-"
                                        between the country code and the number,
                                        which some dialers refuse. */}
                                    <CallLink
                                      record={x}
                                      onCall={() => recordListingEvent(garageOwnerId, 'garage', 'CONTACT')}
                                    >
                                      <i class="fas fa-phone"></i>
                                    </CallLink>
                                  </li>
                                  <li
                                    class="list-inline-item"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Location Map"
                                  >
                                    <a
                                      href="javascript:void(0);"
                                      onClick={handleOpenMap}
                                    >
                                      <i class="fas fa-map-marker-alt"></i>
                                    </a>
                                    <MapModalForView
                                      open={mapModalOpen}
                                      handleClose={handleCloseMap}
                                      currentLocation={{
                                        lat: lat,
                                        long: lng,
                                      }}
                                    />
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="col-12 col-sm-12 col-md-auto">
                            {(isOpen || (nextActionTime && `${nextActionTime}`.trim() !== '')) && (
                    <p class="mb-3">
                              <span class={isOpen ? 'open-time' : 'close-time'}>
                                {isOpen ? t('Open Now') : t('Close Now')}
                              </span>{' '}
                              |{' '}
                              <span class={isOpen ? 'close-time' : 'open-time'}>
                                {isOpen
                                  ? `${t('Closes at')} ${nextActionTime}`
                                  : `${t('Open at')} ${nextActionTime}`}
                              </span>
                            </p>
                  )}
                            <ul className="list-inline mb-0">
                              {x?.website && (
                                <li className="list-inline-item">
                                  <a
                                    href={externalUrl(x?.website)}
                                    target="_blank"
                                    rel="noreferrer"
                                    title="Website"
                                  >
                                    <i
                                      className="fas fa-globe"
                                      style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                                    ></i>
                                  </a>
                                </li>
                              )}
                              {socialMediaData?.INSTAGRAM && (
                                <li className="list-inline-item">
                                  <a href={externalUrl(socialMediaData?.INSTAGRAM)} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src="assets/images/service-provider/instagram.png"
                                      alt="Instagram"
                                    />
                                  </a>
                                </li>
                              )}
                              {socialMediaData?.FACEBOOK && (
                                <li className="list-inline-item">
                                  <a href={externalUrl(socialMediaData?.FACEBOOK)} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src="assets/images/service-provider/facebook.png"
                                      alt="Facebook"
                                    />
                                  </a>
                                </li>
                              )}
                              {socialMediaData?.TWITTER && (
                                <li className="list-inline-item">
                                  <a href={externalUrl(socialMediaData?.TWITTER)} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src="assets/images/service-provider/twitter.png"
                                      alt="Twitter"
                                    />
                                  </a>
                                </li>
                              )}
                              {socialMediaData?.LINKEDIN && (
                                <li className="list-inline-item">
                                  <a href={externalUrl(socialMediaData?.LINKEDIN)} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src="assets/images/service-provider/linkedin.png"
                                      alt="Linkedin"
                                    />
                                  </a>
                                </li>
                              )}
                              {socialMediaData?.YOUTUBE && (
                                <li className="list-inline-item">
                                  <a href={externalUrl(socialMediaData?.YOUTUBE)} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src="assets/images/service-provider/youtube.png"
                                      alt="Youtube"
                                    />
                                  </a>
                                </li>
                              )}
                              {socialMediaData?.SNAPCHAT && (
                                <li className="list-inline-item">
                                  <a href={externalUrl(socialMediaData?.SNAPCHAT)} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src="assets/images/service-provider/snapchat.png"
                                      alt="Snapchat"
                                    />
                                  </a>
                                </li>
                              )}
                              {socialMediaData?.GOOGLEPLUS && (
                                <li className="list-inline-item">
                                  <a href={externalUrl(socialMediaData?.GOOGLEPLUS)} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src="assets/images/service-provider/google-plus.png"
                                      alt="Google Plus"
                                    />
                                  </a>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                        {/* <!-- MAP  MODAL --> */}
                        <div
                          class="modal fade"
                          id="map-modal"
                          tabindex="-1"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">
                                  Map
                                </h5>
                                <button
                                  type="button"
                                  class="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <iframe
                                  title="map"
                                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1781287.9077480363!2d46.414478775959395!3d29.30938918651801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fc5363fbeea51a1%3A0x74726bcd92d8edd2!2sKuwait!5e0!3m2!1sen!2sin!4v1616309027970!5m2!1sen!2sin"
                                  width="100%"
                                  height="450"
                                  style={{ border: '0' }}
                                  allowfullscreen=""
                                  loading="lazy"
                                ></iframe>
                              </div>
                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-dismiss="modal"
                                >
                                  {t('Close')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- MAP  MODAL --> */}

                        {/* <!-- CALENDAR  MODAL --> */}
                        <div
                          class="modal fade"
                          id="calendar-modal"
                          tabindex="-1"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title">{t('Timing')}</h5>
                                <button
                                  type="button"
                                  class="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <table class="table table-bordered table-striped">
                                  <tbody>
                                    <tr>
                                      <td scope="col">{t('Day')}</td>
                                      <td scope="col">{t('Open')}</td>
                                      <td scope="col">{t('Close')}</td>
                                    </tr>
                                    {[
                                      'SUNDAY',
                                      'MONDAY',
                                      'TUESDAY',
                                      'WEDNESDAY',
                                      'THURSDAY',
                                      'FRIDAY',
                                      'SATURDAY',
                                    ].map((day) => {
                                      const status = openStatus.includes(
                                        businessCalendar?.[day]?.status
                                      );

                                      return status ? (
                                        <tr>
                                          <td scope="col">{t(day)}</td>
                                          <td scope="col">
                                            {businessCalendar?.[day]?.openTime}
                                          </td>
                                          <td scope="col">
                                            {businessCalendar?.[day]?.endTime}
                                          </td>
                                        </tr>
                                      ) : (
                                        <tr>
                                          <td scope="col">{t(day)}</td>
                                          <td scope="col">{t('Closed')}</td>
                                          <td scope="col">{t('Closed')}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-dismiss="modal"
                                >
                                  {t('Close')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- CALENDAR  MODAL --> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="main-content-area">
                  <div class="container">
                    <h5 className="cav-section-title">{t('About Us')}</h5>
                    {x?.about?.split('\n').map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}

                    <h5 className="cav-section-title">{t('Services Provided')}</h5>
                    {/* [CF 2026-08-01 v2] One card per service: the service
                        name, then the brands it supports as chips. Only the
                        "Supported Vehicle Types" LABEL was to go — a briefly
                        shipped version dropped the brand chips too, which the
                        client corrected. Uses the SAME `cav-part-card` /
                        `cav-brand-chip` classes as the spare-parts shop card so
                        the two read as one design. */}
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '12px',
                        marginTop: '4px',
                      }}
                    >
                      {(x?.services || []).map((s, si) => {
                        const name = serviceLabel(s?.service);
                        const brandNames = (s?.brands || [])
                          .map((b) => {
                            const brand = b?.brand || b;
                            return isRTL
                              ? brand?.nameAr || brand?.name
                              : brand?.name || brand?.nameAr;
                          })
                          .filter(Boolean);
                        return (
                          <div
                            key={si}
                            className="cav-part-card"
                            style={{
                              flex: '1 1 240px',
                              minWidth: '200px',
                              maxWidth: '360px',
                              textAlign: isRTL ? 'right' : 'left',
                            }}
                          >
                            <div
                              className="cav-part-name"
                              /* no brands → drop the rule, else it dangles */
                              style={
                                brandNames.length
                                  ? undefined
                                  : {
                                      borderBottom: 'none',
                                      marginBottom: 0,
                                      paddingBottom: 0,
                                    }
                              }
                            >
                              {name}
                            </div>
                            {brandNames.length > 0 && (
                              <div className="cav-part-brands">
                                {brandNames.map((bn, bi) => (
                                  <span key={bi} className="cav-brand-chip">
                                    {bn}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      )}
    </div>
  );
}
